export const MONTHLY_SETTLEMENT = '/api/v2/child-settlement/for-parent';
export const MONTHLY_SETTLEMENTS_V2 = '/api/v2/settlement/summary/parent/monthly-settlement';
export const COST_ALLOCATIONS = '/api/v2/child-settlements/cost-split/for-parent';
export const SETTLEMENT_TRANSFER_INFORMATION = '/api/v2/child-settlement/transfer/for-parent';
export const TRANSACTIONS = '/api/v1/transactions/for-parent';

export const SETTLEMENT_CHILDREN = '/api/v1/setting/childStay/parent';
export const CHILD_SETTLEMENT_BALANCE = '/api/v1/balance/for-parent';
export const GET_CORRECTION_INVOICE2 = (correctionId: string) =>
    `/api/v2/child-settlements/correction/for-parent/correction-file/${correctionId}`;
export const ADDITIONAL_COSTS_SETTLEMENT = '/api/v2/settlement/summary/parent/additional-costs';
